import { keyframes } from 'styled-components';

export const fadeReveal = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
